import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { ProForm, ProFormDependency, ProFormDigit, ProFormSelect, ProFormSwitch } from '@ant-design/pro-components';
import dayjs from 'dayjs';
import React from 'react';
export var GlobalSystemSetting = function GlobalSystemSetting() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProForm.Group, {
    title: "\u67E5\u8BE2\u8868\u683C",
    titleStyle: {
      marginBlockEnd: 0
    }
  }, /*#__PURE__*/React.createElement(ProFormSwitch, {
    colProps: {
      xs: 24,
      md: 12
    },
    name: "superProTable.useLegacySearch",
    label: "\u4F7F\u7528\u65E7\u7248\u641C\u7D22\u6846"
  }), /*#__PURE__*/React.createElement(ProFormDependency, {
    name: ['superProTable.useLegacySearch']
  }, function (_ref) {
    var useLegacySearch = _ref['superProTable.useLegacySearch'];
    return useLegacySearch && /*#__PURE__*/React.createElement(ProFormSwitch, {
      colProps: {
        xs: 24,
        md: 12
      },
      name: "superProTable.legacySearch.defaultCollapsed",
      label: "\u9ED8\u8BA4\u6536\u8D77\u641C\u7D22\u6846"
    });
  }), /*#__PURE__*/React.createElement(ProFormDigit, {
    allowClear: true,
    colProps: {
      xs: 24,
      md: 12
    },
    name: "superProTable.automaticRefreshInterval",
    label: "\u81EA\u52A8\u5237\u65B0\u95F4\u9694 (\u6BEB\u79D2)"
  })), /*#__PURE__*/React.createElement(ProForm.Group, {
    title: "\u6307\u4EE4\u9762\u677F",
    titleStyle: {
      marginBlockEnd: 0
    }
  }, /*#__PURE__*/React.createElement(ProFormSwitch, {
    name: "globalCommandPalette.enable",
    label: "\u542F\u7528",
    disabled: true
  })), /*#__PURE__*/React.createElement(ProForm.Group, {
    title: "\u5E03\u5C40",
    titleStyle: {
      marginBlockEnd: 0
    }
  }, /*#__PURE__*/React.createElement(ProFormSwitch, {
    colProps: {
      xs: 24,
      md: 12
    },
    name: "superRootContainer.enableHappyWorkTheme",
    label: "\u542F\u7528\u5FEB\u4E50\u5DE5\u4F5C\u4E3B\u9898"
  }), /*#__PURE__*/React.createElement(ProFormSwitch, {
    colProps: {
      xs: 24,
      md: 12
    },
    name: "superPageContainer.showJumper",
    label: "\u542F\u7528\u591A\u6807\u7B7E\u9875"
  })), /*#__PURE__*/React.createElement(ProForm.Group, {
    title: "\u5176\u5B83",
    titleStyle: {
      marginBlockEnd: 0
    }
  }, /*#__PURE__*/React.createElement(ProFormSelect, {
    colProps: {
      xs: 24
    },
    name: "_.timeZone",
    label: "\u65F6\u533A",
    showSearch: true,
    allowClear: true,
    tooltip: "\u8BBE\u7F6E\u6B64\u5C5E\u6027\u540E\u9700\u8981\u5237\u65B0\u9875\u9762\u624D\u53EF\u4EE5\u751F\u6548",
    request: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", Intl.supportedValuesOf('timeZone').map(function (timeZone) {
              return {
                label: "".concat(timeZone, " (").concat(dayjs().tz(timeZone).format('Z'), ")"),
                value: timeZone
              };
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))
  })));
};